var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "holding-select" },
    [
      _c(
        "v-select",
        {
          attrs: {
            id: "type",
            label: "text",
            options: _vm.holdings,
            clearable: false,
            multiple: "",
            disabled: _vm.loading,
          },
          on: { input: _vm.setHoldings },
          model: {
            value: _vm.holdingsSelected,
            callback: function ($$v) {
              _vm.holdingsSelected = $$v
            },
            expression: "holdingsSelected",
          },
        },
        [
          _c("span", { attrs: { slot: "no-options" }, slot: "no-options" }, [
            _vm._v("Nada que mostrar."),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }